export type KeyValueStorage = {
	getItem: (key: string) => Promise<string | null>;
	setItem: (key: string, value: string) => Promise<void>;
	removeItem: (key: string) => Promise<void>;
};

const hasLocalStorage = (): boolean => typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const storage: KeyValueStorage = {
	getItem: (key) => Promise.resolve(hasLocalStorage() ? window.localStorage.getItem(key) : null),
	setItem: (key, value) => {
		if (hasLocalStorage()) {
			window.localStorage.setItem(key, value);
		}
		return Promise.resolve();
	},
	removeItem: (key) => {
		if (hasLocalStorage()) {
			window.localStorage.removeItem(key);
		}
		return Promise.resolve();
	},
};
